import { themr } from '@friendsofreactjs/react-css-themr';
import { compose } from 'recompose';

import intlEquipped from '../../../../../hocs/intlEquipped';

import CreditBalance from './CreditBalance';

export default compose(
    themr('SapiSubscriptionModuleCreditBalance'),
    intlEquipped
)(CreditBalance);
